<template>
  <div
    class="bg-svg absolute h-screen w-screen bg-cover bg-no-repeat blur-xs"
  ></div>
  <div class="flex h-screen w-screen">
    <form
      @submit.prevent="authStore.login"
      class="bg-base-100 fieldset fade-in-top z-10 m-auto w-80 -translate-y-1/12 p-6"
    >
      <div class="fieldset-legend mb-2">
        <span class="press-start-2p-regular text-primary text-xl font-bold">
        </span>
      </div>

      <label class="input">
        <i class="fa-solid fa-user text-base-content/80"></i>
        <input
          type="text"
          required
          placeholder="Username"
          v-model="authStore.username"
        />
      </label>

      <label class="input">
        <i class="fa-solid fa-key text-base-content/80"></i>
        <input
          type="password"
          required
          placeholder="Password"
          v-model="authStore.password"
        />
      </label>

      <button
        class="btn btn-primary mt-4"
        type="submit"
        :disabled="authStore.loading"
      >
        Sign In
      </button>
    </form>
  </div>
</template>

<script setup lang="ts">
import { use_auth } from "@/auth/useAuth";

const authStore = use_auth();
</script>
